// extracted by mini-css-extract-plugin
module.exports = {"title":"sectionTitle_title__2JX-I"};